import styled from "styled-components";
import { colors } from "@/theme";

export const CardDataContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
`;

export const CardDataTitleContainer = styled.div`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-bottom: 16px;
`;

export const CardInputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;
